import { MY_ASSORTMENT } from '@constants/strings';

export type Path = {
  name: string;
  url: string;
};

export const SUPER_CAT_PATH: Path = {
  name: 'Super CAT',
  url: '/supercat',
};

export const MY_ASSORTMENT_PATH: Path = {
  name: MY_ASSORTMENT,
  url: '/',
};

export const BACKFILL_PATH: Path = {
  name: 'Backfill',
  url: '/backfill',
};

export const AGILE_MANAGEMENT: Path = {
  name: 'Agile Merchandising',
  url: 'agileManagement',
};

export const ASSORTMENT_SEARCH: Path = {
  name: 'Assortment Search',
  url: 'assortmentSearch',
};

export const ZONE_CREATION: Path = {
  name: 'Zone Creation',
  url: 'zoneCreation',
};

export const PRODUCT_READINESS: Path = {
  name: 'Product Readiness',
  url: 'productReadiness',
};

export const PRODUCT_GROUPS: Path = {
  name: 'Product Groups Table',
  url: 'productGroups',
};

export const PATHS = [AGILE_MANAGEMENT, ASSORTMENT_SEARCH, ZONE_CREATION, PRODUCT_READINESS, PRODUCT_GROUPS];

export const GO_PATHS = [PRODUCT_READINESS];
export const GFC_PATHS = [PRODUCT_GROUPS, ZONE_CREATION];
export const GfcEuPaths = [PRODUCT_GROUPS];

// TODO change to Agile specific folders
export const TICKETING_PATH = 'https://t.corp.amazon.com/create/templates/c703a509-e339-4d91-9721-36a4c12a1669';
export const INTAKE_FOLDER_PATH = 'https://sim.amazon.com/issues/create?template=38d9b3cc-fe36-4752-bf6d-9dde558de511';
